

/**
*
* Shared with Build and Client Side
*
*/
requirejs.config({
    config: {
        text: {
            useXhr: function (url, protocol, hostname, port) {
                // allow cross-domain requests
                // remote server allows CORS
                return true;
            }       
        }
    },
    
    shim: {
        // Sites
        "sites/socialpsychology.org/app":     [
			"lib/jquery", 
			"lib/underscore", 
			"lib/backbone", 
			"lib/socket.io", 
			"lib/raphael",
			"plugins/backbone/backbone-validation-amd"
		],

        // Libraries
        "lib/jquery":               [],
        "lib/underscore":           [],
        "lib/backbone":             ["lib/underscore", "lib/jquery"],
        "lib/socket.io":            [],
        "lib/raphael":            	[],

        "plugins/jquery/jcrop/index": ["lib/jquery"],
        "plugins/jquery/sortable": 	  ["lib/jquery"],
		"plugins/backbone/backbone-validation-amd": ["lib/jquery", "lib/underscore", "lib/backbone"],
		

        // Bootstrap plugins
        "plugins/bootstrap/modal":      ["lib/jquery"],
        "plugins/bootstrap/tooltip":    ["lib/jquery"],
        "plugins/bootstrap/dropdown":   ["lib/jquery"],
        "plugins/bootstrap/typeahead":  ["lib/jquery"],
		
		// Leaflet
        "lib/leaflet/index":   ["lib/leaflet/lib"],
		
		"lib/leaflet/lib": {
			exports: 'L'
		},

		// leaflet-google must load after Leaflet so L is available on the global
		"plugins/leaflet-google": ["lib/leaflet/lib"]


        //"plugins/jquery/html5sortable/jquery.sortable.js":  ["lib/jquery"],
    },
    // paths: {
    //  underscore: "lib/underscore",
    //  backbone:   "lib/backbone",
    //  jquery:     "lib/jquery",
    //  socket.io:  "lib/socket.io",
    // },
	
	paths: {
		aloha: "plugins/aloha/lib/aloha-bare",
		"jquery": "lib/jquery",
		"plugins/googleMapsLoaderUtil": "views/account/locationmanager/googleMapsLoaderUtil"
	},
	
    packages: [
        {"name":"css","location":"plugins/requirejs/require-css","main":"css"},
        {"name":"less","location":"plugins/requirejs/require-less","main":"less"},
        {"name":"text","location":"plugins/requirejs","main":"text"},
        {"name":"async","location":"plugins/requirejs/requirejs-plugins/src","main":"async"},
        {"name":"depend","location":"plugins/requirejs/requirejs-plugins/src","main":"depend"},
        {"name":"font","location":"plugins/requirejs/requirejs-plugins/src","main":"font"},
        {"name":"goog","location":"plugins/requirejs/requirejs-plugins/src","main":"goog"},
        {"name":"image","location":"plugins/requirejs/requirejs-plugins/src","main":"image"},
        {"name":"json","location":"plugins/requirejs/requirejs-plugins/src","main":"json"},
        {"name":"mdown","location":"plugins/requirejs/requirejs-plugins/src","main":"mdown"},
        {"name":"noext","location":"plugins/requirejs/requirejs-plugins/src","main":"noext"},
        {"name":"propertyParser","location":"plugins/requirejs/requirejs-plugins/src","main":"propertyParser"},
		
        {"name":"ssi","location":"plugins/requirejs/","main":"ssi"}
    ]
});
define("config", function(){});
